import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { QQShare } from 'ThreeTerminal_mobile';
import { h5PageCount, handleCallNewsApp } from 'ThreeTerminal_utils';
import Grounds from 'ThreeTerminal_base/grounds';
import errorBoundary from '@ifeng/errorBoundary';
import { Picker } from 'antd-mobile';
import SwiperCore, { Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { getCityMap, getPolicy, getLevelArea } from '../../services/api';

import 'antd-mobile/dist/antd-mobile.min.css';
import 'swiper/swiper-bundle.min.css';

SwiperCore.use([Autoplay]);

const Go = ({ startZn, handleClick }) => (
    <div className={styles.area} onClick={handleClick}>
        <span>{startZn}</span>
        <span />
    </div>
);

const Dest = ({ endZn, handleClick }) => (
    <div className={styles.area} onClick={handleClick}>
        <span>{endZn}</span>
        <span />
    </div>
);

Go.propTypes = {
    startZn: PropTypes.string,
    handleClick: PropTypes.func,
};

Dest.propTypes = {
    endZn: PropTypes.string,
    handleClick: PropTypes.func,
};

const Layout = ({ content: { modules, base62Id, shareTitle, shareThumbnail, introduction, devicetype } }) => {
    const [cityMap, setCityMap] = useState([]);
    const [startInfo, setStartInfo] = useState({ start: '110000', startZn: '北京' });
    const [endInfo, setEndInfo] = useState({ end: '130100', endZn: '石家庄' });
    const [startBoxShow, handleStartBoxShow] = useState(false);
    const [endBoxShow, handleEndBoxShow] = useState(false);
    const [startPolicy, setStartPolicy] = useState({});
    const [endPolicy, setEndPolicy] = useState({});
    const [startLevel, setStartLevel] = useState({});
    const [endLevel, setendLevel] = useState({});

    const queryStartPolicy = async code => {
        const policy = await getPolicy(code);

        setStartPolicy({ ...policy });
    };

    const queryEndPolicy = async code => {
        const policy = await getPolicy(code);

        setEndPolicy({ ...policy });
    };

    const getStartLevelData = async start => {
        const level = await getLevelArea(start);

        setStartLevel({ ...level });
    };

    const getEndLevelData = async end => {
        const level = await getLevelArea(end);

        setendLevel({ ...level });
    };

    useEffect(() => {
        try {
            const getCityMapData = async () => {
                const cityMap = await getCityMap();

                setCityMap([...cityMap]);
            };

            getCityMapData();

            const { start } = startInfo;
            const { end } = endInfo;

            queryStartPolicy(end);
            queryEndPolicy(start);

            getStartLevelData(start);
            getEndLevelData(end);
        } catch (e) {
            console.error(e);
        }

        if (devicetype === 'share') {
            // 分享页统计
            h5PageCount([
                {
                    behavior: 'page',
                    type: 'topic',
                    other: {
                        id: `special_ucms_${base62Id}`,
                        url: encodeURIComponent(location.href),
                        ref: encodeURIComponent(document.referrer),
                    },
                },
            ]);
        } else if (devicetype === 'client') {
            Grounds.pageStat({
                id: `special_ucms_${base62Id}`,
                type: 'other',
                url: encodeURIComponent(location.href),
                ref: encodeURIComponent(document.referrer),
            });
        }
    }, []);

    const handleSetStartInfo = val => {
        console.log(val, cityMap);

        const startObj = [...cityMap]
            .filter(item => item.value === val[0])[0]
            .children.filter(child => child.value === val[1])[0];

        setStartInfo({
            start: startObj.value,
            startZn: startObj.label,
        });
        handleStartBoxShow(false);

        queryEndPolicy(val[1]);
        getStartLevelData(val[1]);
    };

    const handleSetEndInfo = val => {
        console.log(val, cityMap);

        const endObj = [...cityMap]
            .filter(item => item.value === val[0])[0]
            .children.filter(child => child.value === val[1])[0];

        setEndInfo({
            end: endObj.value,
            endZn: endObj.label,
        });
        handleEndBoxShow(false);

        queryStartPolicy(val[1]);
        getEndLevelData(val[1]);
    };

    const handleStartAndEndChange = () => {
        const { start, startZn } = startInfo;
        const { end, endZn } = endInfo;

        setStartInfo({
            start: end,
            startZn: endZn,
        });
        setEndInfo({
            end: start,
            endZn: startZn,
        });

        queryStartPolicy(start);
        queryEndPolicy(end);

        getStartLevelData(end);
        getEndLevelData(start);
    };

    const qqShareCofig = {
        title: shareTitle,
        img: shareThumbnail || 'https://p1.ifengimg.com/29b92e35b2b20708/2017/51/ifengLogo300x300.jpg',
        desc: introduction || '',
        cb: () => {
            console.log('分享成功');
        },
    };

    let downloadShow = true;

    if (devicetype === 'pc' || (window && typeof window.grounds !== 'undefined')) {
        downloadShow = false;
    }

    const getChinaUrl = () => {
        let url = '';

        if (devicetype === 'share') {
            url = 'https://ishare.ifeng.com/c/s/7tPlDSzDgVk?needpage=1&webkit=1';
        } else if (devicetype === 'client') {
            url = 'https://news.ifeng.com/c/specialClient/7tPlDSzDgVk?needpage=1&webkit=1';
        } else {
            url = 'https://news.ifeng.com/c/special/7tPlDSzDgVk?needpage=1&webkit=1';
        }

        if (window.location.href.indexOf('srctag') > -1) {
            url = 'https://news.ifeng.com/c/vivo/7tPlDSzDgVk';
        }

        return url;
    };

    const handleClick = () => {
        h5PageCount([
            {
                behavior: 'action',
                type: 'topic',
                other: {
                    id: `special_ucms_${base62Id}`,
                    url: encodeURIComponent(location.href),
                    ref: encodeURIComponent(document.referrer),
                },
            },
        ]);

        const nodata = '';
        const doc_type = 'topic3';
        const aid = '7sqjPxP22fg';
        const to_url = 'https://news.ifeng.com/c/special/7sqjPxP22fg';
        const downloads = {
            download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1450306105889',
            downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8791',
        };

        handleCallNewsApp(nodata, doc_type, aid, to_url, 0, 0, 'inter_fxyzt02', { noPrefixKind: true }, downloads);
    };

    const tips = modules[0].data;
    const infoUrl = modules[0].data[0].info.url;

    return (
        <div className={styles.layout}>
            <QQShare content={qqShareCofig} />
            <div className={styles.banner} />
            <div className={styles.option_box}>
                <div className={styles.option}>
                    <div className={styles.select_box}>
                        <Picker
                            cols={2}
                            visible={startBoxShow}
                            data={[...cityMap]}
                            onOk={val => handleSetStartInfo(val)}
                            onDismiss={() => handleStartBoxShow(false)}>
                            <Go startZn={startInfo.startZn} handleClick={() => handleStartBoxShow(true)} />
                        </Picker>
                        <span onClick={handleStartAndEndChange} />
                        <Picker
                            cols={2}
                            visible={endBoxShow}
                            data={[...cityMap]}
                            onOk={val => handleSetEndInfo(val)}
                            onDismiss={() => handleEndBoxShow(false)}>
                            <Dest endZn={endInfo.endZn} handleClick={() => handleEndBoxShow(true)} />
                        </Picker>
                    </div>
                    <p>最新更新时间：{startPolicy.updateTime}</p>
                </div>
            </div>
            <div className={styles.content}>
                <div className={styles.tip_box}>
                    <span />
                    <div className={styles.tip}>
                        <Swiper loop autoplay autoHeight height={40} direction="vertical">
                            {tips.map((item, index) => (
                                <SwiperSlide key={index}>
                                    <a href={infoUrl} target="_blank">
                                        <span>{item.summary}</span>
                                    </a>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                    <span />
                </div>
                <div className={styles.title}>
                    <span />
                    <span>落地政策</span>
                </div>
                <div className={styles.start_policy}>
                    <div className={styles.travel_title}>
                        <span />
                        <span>
                            {startInfo.startZn}-{endInfo.endZn}
                        </span>
                    </div>
                    <div className={styles.policy_content}>
                        {startPolicy.policy && startPolicy.policy.length
                            ? startPolicy.policy.map(item => <p key={item}>{item}</p>)
                            : '暂无相关政策信息'}
                    </div>
                </div>
                <div className={styles.end_policy}>
                    <div className={styles.travel_title}>
                        <span />
                        <span>
                            {endInfo.endZn}-{startInfo.startZn}
                        </span>
                    </div>
                    <div className={styles.policy_content}>
                        {endPolicy.policy && endPolicy.policy.length
                            ? endPolicy.policy.map(item => <p key={item}>{item}</p>)
                            : '暂无相关政策信息'}
                    </div>
                </div>
                <div className={styles.title}>
                    <span />
                    <span>风险地区提示</span>
                </div>
                <div className={styles.start_level}>
                    <div className={styles.start_area}>
                        <span>
                            <span />
                            <span>{startInfo.startZn}</span>
                        </span>
                        <span>{startLevel.updateTime && `${startLevel.updateTime}更新`}</span>
                    </div>
                    <div className={styles.start_level_info}>
                        {startLevel.updateTime ? (
                            <Fragment>
                                <span>{startLevel.high && startLevel.high.length}</span>个高风险
                                <span>{startLevel.mid && startLevel.mid.length}</span>个中风险
                            </Fragment>
                        ) : (
                            '暂无相关信息'
                        )}
                    </div>
                    {startLevel.high &&
                        startLevel.high.map((item, index) => (
                            <div key={index} className={styles.high_level_item}>
                                <p>{item.zone}</p>
                                <span>高风险</span>
                            </div>
                        ))}
                    {startLevel.mid &&
                        startLevel.mid.map((item, index) => (
                            <div key={index} className={styles.mid_level_item}>
                                <p>{item.zone}</p>
                                <span>中风险</span>
                            </div>
                        ))}
                </div>
                <div className={styles.end_level}>
                    <div className={styles.end_area}>
                        <span>
                            <span />
                            <span>{endInfo.endZn}</span>
                        </span>
                        <span>{endLevel.updateTime && `${endLevel.updateTime}更新`}</span>
                    </div>
                    <div className={styles.start_level_info}>
                        {endLevel.updateTime ? (
                            <Fragment>
                                <span>{endLevel.high && endLevel.high.length}</span>个高风险
                                <span>{endLevel.mid && endLevel.mid.length}</span>个中风险
                            </Fragment>
                        ) : (
                            '暂无相关信息'
                        )}
                    </div>
                    {endLevel.high &&
                        endLevel.high.map((item, index) => (
                            <div key={index} className={styles.high_level_item}>
                                <p>{item.zone}</p>
                                <span>高风险</span>
                            </div>
                        ))}
                    {endLevel.mid &&
                        endLevel.mid.map((item, index) => (
                            <div key={index} className={styles.mid_level_item}>
                                <p>{item.zone}</p>
                                <span>中风险</span>
                            </div>
                        ))}
                </div>
            </div>
            {downloadShow && (
                <div className={styles.download}>
                    <a href={getChinaUrl()}>
                        <span>查看疫情地图</span>
                    </a>
                    <div onClick={handleClick}>
                        <span>进入疫情专题</span>
                    </div>
                </div>
            )}
        </div>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
